import { render, staticRenderFns } from "./PopupLevel.vue?vue&type=template&id=5ae3c282&scoped=true&"
import script from "./PopupLevel.vue?vue&type=script&lang=js&"
export * from "./PopupLevel.vue?vue&type=script&lang=js&"
import style0 from "./PopupLevel.vue?vue&type=style&index=0&id=5ae3c282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae3c282",
  null
  
)

export default component.exports